var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
export class AlfatronSmw42 {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                unterminatedRegExp: /login:\s*/i,
                next: /login:\s*/i,
            },
            {
                errorCode: 'authFailed',
                send: 'root',
                unterminatedRegExp: /Username:|login:|Password:\s*/i,
                fail: /Username:|login:\s*/i,
                next: /Password:\s*/i,
            },
            {
                errorCode: 'authFailed',
                send: (cred) => {
                    return '';
                },
                unterminatedRegExp: /.*/i,
                fail: /Login incorrect|login:\s*/i,
                next: /Welcome to HiLinux|~ #/i,
            },
        ];
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`gbconfig --show ${key === '1' ? 'source-select' : 'secondary-output'}`, 
                // If there is no source selescted, NULL is returned. Due to multiple layouts, it
                // is possible to receive multiple sources from key = 1.
                /(HDMI\d|TYPE-C|VGA|IPV\d+|Dongle\d+|GUIDE|NULL)|(Duplication mode, same as the primary output)/i, tags);
                if (match[1]) {
                    // Return the first source if multiple sources are returned.
                    const videoSources = match[1].split(' ');
                    return videoSources[0] === 'NULL' ? 'GUIDE' : videoSources[0];
                }
                else if (match[2]) {
                    // If in duplicated-dualoutput mode, then the video source selected for output 2
                    // is the same as the video source selected for output 1.
                    return key === '2'
                        ? this.state.videoMatrixRoutes.values['1']
                        : this.state.videoMatrixRoutes.values[key];
                }
                return this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                if (key === '1') {
                    // Set to one image on screen and then set the source.
                    yield this.socket.sendAsync(`gblayout --set 0x100`, tags);
                    const match = yield this.socket.send(`gbconfig --source-select ${value}`, /\[Event\] Layout (0x\d+) layout\d+|gbconfig --source-select ({\s*VideoName\s*})|The designated BYOD session has been closed/i, tags);
                    if (match[2])
                        return this.state.videoMatrixRoutes.values[key];
                    return value;
                }
                else if (key === '2') {
                    // Output 2 always only supports one video signal on the screen so we don't need to
                    // change layouts when controlling in duplicated-dualoutput = n mode.
                    //
                    // There is no response from setting the secondary output.
                    //
                    // Set to an unused input first since there are times where the instructions are
                    // shown but the query shows that another input is active.  Setting it to the same
                    // input doesn't make the output change. Setting to GUIDE and then the valid output
                    // makes the input change.
                    yield this.socket.sendAsync(`gbconfig --secondary-output GUIDE`);
                    yield this.socket.sendAsync(`gbconfig --secondary-output ${value}`);
                    return value;
                }
                return this.state.videoMatrixRoutes.values[key];
            }),
            asyncHandlers: [
                {
                    regExp: /\[Event\] VideoSource\s*(Dongle\d+|HDMI\d+|TYPE-C|VGA|IPV\d+|GUIDE)\s*(NoSignal)?/i,
                    callback: (match) => {
                        if (!match[2]) {
                            // If the source is shown as valid, then update selection.
                            const value = match[1];
                            const key = '1';
                            this.state.videoMatrixRoutes.update(key, value);
                        }
                    },
                },
            ],
        };
        // polling
        this.polls = [{ intervalMs: 3000, controls: ['videoMatrixRoutes'] }];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            // Turn auto layout switching off so switching to a new source shows the source full screen.
            // There is no response from this command.
            yield this.socket.sendAsync('gblayout --auto n', ['configure']);
            // Configure auto switching based on Mal settings
            yield this.socket.sendAsync(`gbconfig --auto-switch-source ${(config === null || config === void 0 ? void 0 : config.autoSwitchVideoInputs) ? 'y' : 'n'}`, ['configure']);
            // Set the system into Matrix mode when not in autoswitch mode.  We may want a separate
            // Mal option for matrix mode vs. duplicating the output on the second output.
            yield this.socket.sendAsync(`gbconfig --duplicated-dualoutput ${(config === null || config === void 0 ? void 0 : config.autoSwitchVideoInputs) ? 'y' : 'n'}`, ['configure']);
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
AlfatronSmw42.driverType = 'socketDriver';
AlfatronSmw42.key = '-MYjKk2F4nA3FU9I4TtD';
AlfatronSmw42.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
};
AlfatronSmw42.socketOptions = [
    Object.assign(Object.assign({}, AlfatronSmw42.baseSocketOptions), { port: 24 }),
    Object.assign(Object.assign({}, AlfatronSmw42.baseSocketOptions), { port: 4999 }),
];
